// In its own file so fetch.tsx can react to 401s by invalidating the status
// query without importing loggedInStatus.ts, which imports its request
// helpers from fetch.tsx - that import would be a cycle.
export const loggedInStatusQueryKey = ["logged_in_status"] as const;
